import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <div className="footerContent">
                <div className="footerContentLeft">
                    <img src="/logo.png" alt="Blitz Fiber Logo" className="footerLogo" />
                    <p className="footerDescription">
                        Blitz Fiber is a leading provider of construction materials and services. We are committed to providing the best quality products and services to our customers.
                    </p>
                </div>
                <div className="footerContentRight">
                    <div className="footerContentRightItem">
                        <h3 className="footerContentRightItemHeading">About</h3>
                        <ul className="footerContentRightItemList">
                            <li className='footerContentRightItemLink'>Company</li>
                            <li className='footerContentRightItemLink'>Products</li>
                            <li className='footerContentRightItemLink'>Contact</li>
                        </ul>
                    </div>
                    <div className="footerContentRightItem">
                        <h3 className="footerContentRightItemHeading">Contact</h3>
                        <ul className="footerContentRightItemList">
                            +91 96546 22026
                        </ul>
                        <ul className="footerContentRightItemList">
                            <li className='footerContentRightItemLink'>info.blitzfibresariya@gmail.com</li>
                        </ul>
                        <ul className="footerContentRightItemList">
                            <li className='footerContentRightItemLink'>plot gata number 125, bulanshshahr road, sikanddrabad, Uttar pradesh 203205</li>
                        </ul>
                        <ul className="footerContentRightItemList">
                            <li className='footerContentRightItemLink'>Monday - Friday: 9:00 AM - 5:00 PM</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer